<mat-divider aria-hidden="true" [inset]="inset"></mat-divider>
